"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSiteUseCase = void 0;
const sites_1 = require("@/services/sites");
const sites_2 = require("@/store/ducks/sites");
const listSitesUseCase_1 = require("./listSitesUseCase");
function createSiteUseCase(siteName, siteLocation) {
    return (dispatch) => {
        dispatch((0, sites_2.createSite)());
        return (0, sites_1.createSiteService)(siteName, siteLocation)
            .then(async () => {
            dispatch((0, sites_2.createSiteSuccess)());
            await (0, listSitesUseCase_1.listSites)()(dispatch);
            dispatch((0, sites_2.closeAddSiteModal)());
            dispatch(openSiteToast({
                status: "success",
                message: "Site created successfully",
            }));
        })
            .catch(() => {
            dispatch((0, sites_2.createSiteError)());
            dispatch(openSiteToast({
                status: "error",
                message: "Error creating system",
            }));
        });
    };
}
exports.createSiteUseCase = createSiteUseCase;
function openSiteToast(arg0) {
    throw new Error("Function not implemented.");
}
